module.exports = __webpack_public_path__ + "static/media/Udacity_Logo.53be8142.png";